function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 3.5v2M7 3.5v2M3 8.5h16M19 12.917V6.5a2 2 0 00-2-2H5a2 2 0 00-2 2v11a2 2 0 002 2h7.417",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.999 11.25a.25.25 0 10.002.5.25.25 0 00-.002-.5M6.999 15.25a.25.25 0 10.002.5.25.25 0 00-.002-.5M10.75 11.501a.25.25 0 10.5-.002.25.25 0 00-.5.002",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17 22.5a5 5 0 01-5-5c0-2.704 2.3-5.003 5.004-5a5 5 0 01-.004 10",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17 15.5v4M19 17.5h-4",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgCalendarAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgCalendarAdd;